import { FC } from "react"
import { useDLMResponseFormContext } from "../../components/DLMResponseFormContext"
import { IDLMWebROIModel } from "../../../../../core/doclabel"

type Props = {
    index: number
    onGenROI: Function
    baseData: IDLMWebROIModel
}

const DLMGenerateROIButton: FC<Props> = ({index, onGenROI, baseData}) => {
    
    const { setBaseROI, setGenROIIndex, setOnGenROI, generateROI } = useDLMResponseFormContext();
    
    return(
    <button
        type="button"
        className='btn btn-sm btn-light-secondary py-1 mb-1 px-3'
        onClick={() => {
            setBaseROI(baseData);
            setGenROIIndex(index);
            setOnGenROI(() => onGenROI);
            generateROI();            
        }}        
    >
        <span className='indicator-label'>Generate ROI</span>        
    </button>
    )
}

export {DLMGenerateROIButton}